import type { BoxProps, TabProps, TabsState } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';
import { Panel as LayoutPanel } from '../../../../Layout/Components/Panel';
import type { LayoutPanelApi } from '../../../types';
import { PanelBlotterTableStorageProvider } from './PanelBlotterTableStorageProvider';
import type { PanelBlottersState } from './panelPersistence';
import { PanelTabsStorageProvider } from './PanelTabsStorageProvider';

type BlotterPanelProps = PropsWithChildren<
  BoxProps & {
    panelApi: LayoutPanelApi;
    panelTabs: TabsState<TabProps> | undefined;
    panelBlottersState?: PanelBlottersState;
  }
>;

/**
 * Shared shell for trading blotter panels that need panel-param-backed
 * tabs and blotter table persistence.
 */
export function BlotterPanel({ panelApi, panelTabs, panelBlottersState, children, ...panelProps }: BlotterPanelProps) {
  return (
    <LayoutPanel panelApi={panelApi} {...panelProps}>
      <PanelTabsStorageProvider panelApi={panelApi} panelTabs={panelTabs}>
        <PanelBlotterTableStorageProvider panelApi={panelApi} panelBlottersState={panelBlottersState}>
          {children}
        </PanelBlotterTableStorageProvider>
      </PanelTabsStorageProvider>
    </LayoutPanel>
  );
}
